import axios from "axios";
import { api } from "../config";

// Internal login route for handling missing/expired/invalid tokens
const LOGIN_REDIRECT_URL = "/login";

// default
axios.defaults.baseURL = api.API_URL;
// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

/**
 * Initialize Authorization header from stored token.
 * Priority:
 * 1. Explicit token passed via setAuthorization (e.g., after login/URL parsing)
 * 2. Token in localStorage ("authToken")
 * 3. Token in sessionStorage ("authUser".token)
 */
const initializeAuthHeader = () => {
  if (typeof window === "undefined") return;

  let token = null;

  const localToken = window.localStorage.getItem("authToken");
  if (localToken) {
    token = localToken;
  } else {
    const user = window.sessionStorage.getItem("authUser");
    if (user) {
      try {
        const parsed = JSON.parse(user);
        if (parsed && parsed.token) {
          token = parsed.token;
        }
      } catch {
        // ignore JSON errors
      }
    }
  }

  if (token) {
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  }
};

initializeAuthHeader();

// intercepting to capture errors
axios.interceptors.response.use(
  function (response) {
    // Handle logical "invalid token" responses that still return 200
    const data = response && response.data ? response.data : response;
    const isInvalidToken =
      data &&
      typeof data === "object" &&
      data.status === false &&
      typeof data.message === "string" &&
      /invalid token/i.test(data.message);

    if (isInvalidToken) {
      if (typeof window !== "undefined") {
        window.localStorage.removeItem("authToken");
        window.sessionStorage.removeItem("authUser");
        if (window.location.pathname !== "/login") {
  window.location.href = LOGIN_REDIRECT_URL;
}
      }
      return Promise.reject(data.message || "Invalid token");
    }

    return response.data ? response.data : response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    const status = error && error.response ? error.response.status : undefined;

    // If unauthorized or token is invalid/expired, redirect to client portal login
    if (status === 401 || status === 403) {
      if (typeof window !== "undefined") {
        window.localStorage.removeItem("authToken");
        window.sessionStorage.removeItem("authUser");
        if (window.location.pathname !== "/login") {
  window.location.href = LOGIN_REDIRECT_URL;
}
      }
    }

    let message;
    switch (status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401:
        message = "Invalid credentials";
        break;
      case 404:
        message = "Sorry! the data you are looking for could not be found";
        break;
      default:
        message = (error && error.message) || error;
    }
    return Promise.reject(message);
  }
);
/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token) => {
  if (!token) return;
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  if (typeof window !== "undefined") {
    window.localStorage.setItem("authToken", token);
    window.sessionStorage.setItem("authUser", JSON.stringify({ token }));
  }
};

class APIClient {
  /**
   * Fetches data from given url
   */

  //  get = (url, params) => {
  //   return axios.get(url, params);
  // };
  get = (url, params) => {
    let response;

    let paramKeys = [];

    if (params) {
      Object.keys(params).map(key => {
        paramKeys.push(key + '=' + params[key]);
        return paramKeys;
      });

      const queryString = paramKeys && paramKeys.length ? paramKeys.join('&') : "";
      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(`${url}`, params);
    }

    return response;
  };
  /**
   * post given data to url
   */
  create = (url, data) => {
    return axios.post(url, data);
  };
  /**
   * Updates data
   */
  update = (url, data) => {
    return axios.patch(url, data);
  };

  put = (url, data) => {
    return axios.put(url, data);
  };
  /**
   * Delete
   */
  delete = (url, config) => {
    return axios.delete(url, { ...config });
  };
}
const getLoggedinUser = () => {
  const user = sessionStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export { APIClient, setAuthorization, getLoggedinUser };